import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "./Supabase/SupabaseClient.js";
import Navbar from "./Components/Nav/Navbar.js";
import Home from "./Pages/Clients/Home.jsx";
import Admin from "./Pages/Admin/Admin.jsx";
import Login from "./Pages/Clients/Login.jsx";
import Compra from "./Pages/Clients/Compra.jsx";
import MisFavoritos from "./Pages/Clients/Favorito/Favoritos.jsx";
import Reserva from "./Pages/Clients/Reserva.jsx";
import Reservas from "./Pages/Admin/Components/Reservas/Reservas.js";
import Registro from "./Pages/Clients/Registro.jsx";
import Dashboard from "./Pages/Admin/Components/Card-admin/Dashboard.jsx";
import Inspiracion from "./Pages/Clients/Inspiracion/Inspiracion.jsx";
import ServicioDetalle from "./Pages/Clients/Servicio/ServicioDetalle.jsx";
import Contratos from "./Pages/Admin/Components/Contratos/Contratos.js";
import { CartProvider } from "./Pages/Clients/context/CartContext.js";
import AuthListenerWrapper from "./Pages/Clients/AuthListenerWrapper.js";
import ProtectedRoute from "./RutasProtegidas/ProtectedRoute.js";
import Hiring from "./Pages/Clients/Trabaja/Hiring.js";
import Contrato from "./Pages/Clients/Contrato/Contrato.js";
import Sesiones from "./Pages/Clients/Sesiones/Sesiones.js";
import Provedores from "./Pages/Clients/Proveedores/Provedores.js";
import DetalleReserva from "./Pages/Clients/DetalleReserva.jsx";
import AdminSesiones from "./Pages/Admin/Sesion/AdminSesiones.js";
import InspiracionAdmin from "./Pages/Admin/Components/Card-admin/InspiracionAdmin.jsx";
import Error404 from "./Components/Error404/Error404.js";
import Politicas from "./Components/Politicas-privacidad/Politicas.js";
import Terminos from "./Components/Politicas-privacidad/Terminos.js";
import FAQ from "./Pages/Clients/FAQ.jsx";

function App() {
  const [user, setUser] = useState(null);
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    // Cargar sesión existente al montar (incluye token del hash de OAuth)
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser(session.user);
        setProfileImage(session.user.user_metadata?.avatar_url || "/placeholder.svg");
      }
      // Limpiar hash DESPUÉS de que Supabase procesó el token
      if (window.location.hash.includes("access_token")) {
        window.history.replaceState(null, document.title, window.location.pathname);
      }
    });

    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session?.user) {
          setUser(session.user);
          setProfileImage(session.user.user_metadata?.avatar_url || "/placeholder.svg");
        } else {
          setUser(null);
          setProfileImage(null);
        }
      }
    );

    return () => authListener.subscription.unsubscribe();
  }, []);

  const loginWithGoogle = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: { redirectTo: window.location.origin },
      });
      if (error) console.error("Error al iniciar sesión con Google:", error);
    } catch (error) {
      console.error("Error al iniciar sesión con Google:", error);
    }
  };

  return (
    <CartProvider>
      <Router>
        <AuthListenerWrapper />
        <div className="App">
          <Navbar user={user} profileImage={profileImage} loginWithGoogle={loginWithGoogle} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login loginWithGoogle={loginWithGoogle} />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/favoritos" element={<MisFavoritos />} />
            <Route path="/inspiracion" element={<Inspiracion />} />
            <Route path="/carrito" element={<Compra />} />
            <Route path="/plan" element={<Navigate to="/contrato" replace />} />
            <Route path="/reserva" element={<Reserva />} />
            <Route path="/servicios/:slug" element={<ServicioDetalle />} />
            <Route path="trabaja-con-nosotros" element={<Hiring />} />
            <Route path="/contrato" element={<Contrato />} />
            <Route path="/sesiones" element={<Sesiones />} />
            <Route path="/proveedores" element={<Provedores />} />
            <Route path="/detalle-reserva" element={<DetalleReserva />} />
            <Route path="*" element={<Error404 />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/politicas" element={<Politicas />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/inspiracion-admin" element={<ProtectedRoute element={<InspiracionAdmin standalone />} />} />
            <Route path="/contratos" element={<ProtectedRoute element={<Contratos />} />} />
            <Route path="/reservas" element={<ProtectedRoute element={<Reservas standalone />} />} />
            <Route path="/admin" element={<ProtectedRoute element={<Admin />} />} />
            <Route path="/admin-sesiones" element={<ProtectedRoute element={<AdminSesiones />} />} />
            <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
          </Routes>
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;